import React, { ChangeEvent, useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Col, Row } from 'react-bootstrap';
import { FaCloudUploadAlt } from 'react-icons/fa';
import Input from '../../../components/Input';
import Loading from '../../../components/Loading';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import getValidationErrors from '../../../utils/getValidationErrors';
import { ICertificados } from '.';
import { CertificadoInput, Content } from './styles';

interface IFormBusca {
  DataValidade: Date;
}

type CertificadoProps = {
  usuCodigo: number;
  handleDadosSalvos(dados: ICertificados): void;
};

const CadastroCertificado: React.FC<CertificadoProps> = ({
  usuCodigo,
  handleDadosSalvos,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const formRefBusca = useRef<FormHandles>(null);
  const [arquivo, setArquivo] = useState(undefined);
  const [nomeArquivo, setNomeArquivo] = useState('');

  const handleSalvar = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});

        if (!arquivo) {
          addToast({
            title: 'Certificado',
            type: 'error',
            description: 'Selecione um certificado',
          });
          return;
        }
        const dadosEnvio = new FormData();
        dadosEnvio.append('DataValidade', dados.DataValidade.toString());
        dadosEnvio.append('certificado', arquivo || '');

        const response = await api.patch(
          `/medicos/certificado/${usuCodigo}`,
          dadosEnvio,
        );

        handleDadosSalvos(response.data);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        }
        const mensagem = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar dados',
          type: 'error',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, usuCodigo, handleDadosSalvos, arquivo],
  );

  const handleCertificadoChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        setLoading(true);
        try {
          const { files } = e.target;
          const filesArr = Array.prototype.slice.call(files);
          setArquivo(filesArr[0]);
          setNomeArquivo(filesArr[0].name);
        } catch (error) {
          addToast({
            type: 'error',
            title: 'Houve um erro ao atualziar o Certificado',
          });
        } finally {
          setLoading(false);
        }
      }
    },
    [addToast],
  );

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}

      <Content>
        <>
          <Row>
            <Col md={6}>
              <CertificadoInput>
                <label htmlFor="certificado">
                  <FaCloudUploadAlt size="20" />
                  <b style={{ paddingLeft: '5px', display: 'block' }}>
                    Certificado
                  </b>
                  <input
                    type="file"
                    id="certificado"
                    onChange={handleCertificadoChange}
                  />
                </label>
                <div>
                  <b style={{ display: 'block' }}>{nomeArquivo}</b>
                </div>
              </CertificadoInput>
            </Col>
            <Col md={3}>
              <Form ref={formRefBusca} onSubmit={handleSalvar}>
                <Input
                  name="DataValidade"
                  label="Validade"
                  type="date"
                  required
                />
              </Form>
            </Col>
            <Col md={3}>
              <div style={{ marginBottom: '4px', display: 'block' }}>
                &nbsp;
              </div>
              <Button
                type="button"
                onClick={() => formRefBusca?.current?.submitForm()}
                size="sm"
                variant="success"
              >
                Salvar dados
              </Button>
            </Col>
          </Row>
        </>
      </Content>
    </>
  );
};

export default CadastroCertificado;
